import { SSM } from '@aws-sdk/client-ssm';
import { isNullOrUndefined, validateNotEmptyString } from '@weft/utils';
import type { ZodSchema } from 'zod';

export const ssmClient = new SSM();

export async function getRawParametersByPath(path: string) {
  console.info(`Getting parameters by path: ${path}`);
  const getParametersResult = await ssmClient.getParametersByPath({ Path: path });
  console.info(`Got ${getParametersResult.Parameters?.length} parameters by path: ${path}`);

  return getParametersResult.Parameters;
}

export async function getParsedParametersByPath<SchemaType>(path: string, schema: ZodSchema<SchemaType>): Promise<SchemaType> {
  const rawParameters = await getRawParametersByPath(path);
  
  if (isNullOrUndefined(rawParameters)) {
    throw new Error(`No parameters found for path: ${path}`);
  }

  const parsedParameters = rawParameters.reduce((currentParsedParameters, parameter) => {
    const { Name, Value, Type } = parameter;

    validateNotEmptyString(Name);
    const key = Name.split('/').pop();

    validateNotEmptyString(key);

    const parsedValue = Type === 'StringList' ? parseStringListValue(Value) : Value;

    return { ...currentParsedParameters, [key]: parsedValue };
  }, {});

  return schema.parse(parsedParameters);
}

function parseStringListValue(value: string | undefined): string[] {
  if (isNullOrUndefined(value) || value === ',') {
    return [];
  }

  return value.split(',');
}